export const transformValueForSentence = (value: string, placeholder: string, promptTemplate: string) => {
  const placeholderIndex = promptTemplate.indexOf(placeholder)
  if (placeholderIndex === -1) return value

  const beforeChar = placeholderIndex > 0 ? promptTemplate[placeholderIndex - 1] : ''
  const afterChar = placeholderIndex + placeholder.length < promptTemplate.length 
    ? promptTemplate[placeholderIndex + placeholder.length] 
    : ''

  const isWithinSentence = (
    (beforeChar && beforeChar !== ' ' && beforeChar !== '\n') ||
    (afterChar && afterChar !== ' ' && afterChar !== '\n' && afterChar !== '.')
  )

  if (isWithinSentence && value) {
    return value.charAt(0).toLowerCase() + value.slice(1)
  }

  return value
}

export const getPopulatedPrompt = (values: {
  decisionNeeded: string;
  contextAndGoals: string;
  optionsConsidered: string;
  constraints: string;
  referenceFiles: string;
}, uploadedFiles: Array<{ name: string; url: string; }>, promptTemplate: string) => {
  let prompt = promptTemplate;

  // Replace placeholders in the template
  prompt = prompt.replace('[Decision details will be inserted here]', values.decisionNeeded);
  prompt = prompt.replace('[Context and goals will be inserted here]', values.contextAndGoals);
  prompt = prompt.replace('[Options will be inserted here]', values.optionsConsidered);
  prompt = prompt.replace('[Constraints will be inserted here]', values.constraints);

  // Add context section if there's any user input
  const contextSection = `Context from user input:
${values.contextAndGoals}

Timeline & Constraints:
${values.constraints}

`;

  prompt = prompt.replace('[Context from user input will be added here]', contextSection);

  // Add reference materials if any
  if (uploadedFiles.length > 0) {
    const referenceSection = `\nReference Materials:
${uploadedFiles.map(file => `- ${file.name} (${file.url})`).join('\n')}
`;
    prompt += referenceSection;
  }

  return prompt;
}